import request from '@/utils/request'

export function login(username, password, code, uuid, captchaVerifyParam) {
  return request({
    url: 'auth/login',
    method: 'post',
    data: {
      username,
      password,
      code,
      uuid,
      captchaVerifyParam
    }
  })
}

// 获取加密场景ID（阿里云验证码加密模式，服务端用 eKey 加密 sceneId 下发）
// 登录页匿名调用，失败时静默降级为明文场景ID，不触发全局登录过期弹窗
export function encryptCaptchaSceneId(sceneId) {
  return request({
    url: `auth/encrypt/${sceneId}`,
    method: 'post',
    silentError: true
  })
}

export function smsLogin(data) {
  return request({
    url: 'auth/sms/login',
    method: 'post',
    data
  })
}


export function getInfo() {
  return request({
    url: 'auth/info',
    method: 'get'
  })
}

export function getCodeImg() {
  return request({
    url: 'auth/code',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: 'auth/logout',
    method: 'delete'
  })
}

//获取平台信息
export function getAccessPlatformInfo() {
  return request({
    url: 'auth/access/platform/info',
    method: 'get'
  })
}

//获取企业业务信息
export function getEntBusinessInfo(params) {
  return request({
    url: '/api/manage/customer/business/list',
    method: 'get',
		params
  })
}

//忘记密码第一步
export function forgetStepOne(data) {
  return request({
    url: '/api/forget/step/one',
    method: 'post',
    data
  })
}


//忘记密码第二步（POST：uuid 与验证码票据均放请求体，避免 URL 超长与路径暴露）
export function forgetStepTwo(uuid, params) {
  return request({
    url: '/api/forget/step/two',
    method: 'post',
    data: { uuid, ...params }
  })
}


//忘记密码第三步
export function forgetStepThree(data) {
  return request({
    url: '/api/forget/step/three',
    method: 'post',
    data
  })
}


//受信登录
export function sendTrustSms(data) {
  return request({
    url: 'auth/trust/sms',
    method: 'post',
    data
  })
}

//受信登录
export function trustAuthLogin(data) {
  return request({
    url: 'auth/trust',
    method: 'post',
    data
  })
}

// 切换企业
export function entChange(data) {
  return request({
    url: '/auth/switch',
    method: 'post',
    data
  })
}

//验证登录验证码
export function checkCode(data){
  return request({
    url: 'auth/check/code',
    data,
    method: 'put'
  })
}

// 关联企业列表
export function getEnterpriseList(){
  return request({
    url: '/api/user/enterprise/list',
    method: 'GET'
  })
}


// 同意登录协议
export function agreeloginAgreement(data){
  return request({
    url: '/auth/agree',
    method: 'post',
    data
  })
}


// 企业入驻链接(二维码)生成
export function generateLink(data) {
  return request({
    url: `/api/manage/labor/generate/qrcode`,
    method: 'post',
		data
  })
}


//发送注册短信验证码
export function getRegisterSmsCode(data) {
  return request({
    url: '/auth/register/smsCode/send',
    method: 'post',
    data
  })
}
//发送登录短信验证码
export function getLoginSmsCode(data) {
  return request({
    url: '/auth/sms/login/send',
    method: 'post',
    data
  })
}
//注册
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

//获取用户详情
export function getUserDetail() {
  return request({
    url: '/api/login/user/detail',
    method: 'get'
  })
}

//获取用户登录日志
export function getUserLoginLogPage(data) {
  return request({
    url: '/api/login/user/login/log/page',
    method: 'get',
    params: data
  })
}

//获取用户操作日志
export function getUserOptLogPage(data) {
  return request({
    url: '/api/login/user/opt/log/page',
    method: 'get',
    params: data
  })
}

//获取用户安全设置
export function getUserSecurity() {
  return request({
    url: '/api/login/user/security',
    method: 'get'
  })
}

//设置用户安全设置
export function setUserSecurity(data) {
  return request({
    url: '/api/login/user/security/set',
    method: 'post',
    data
  })
}


//更新用户邮箱
export function updateUserEmail(data) {
  return request({
    url: '/api/login/user/update/email',
    method: 'post',
    data
  })
}

//更新用户名
export function updateUserName(data) {
  return request({
    url: '/api/login/user/update/name',
    method: 'post',
    data
  })
}

//更新用户手机号
export function updateUserPhone(data) {
  return request({
    url: '/api/login/user/update/phone',
    method: 'post',
    data
  })
}
